import { render, staticRenderFns } from "./AdminMessageTemplate.vue?vue&type=template&id=2e3a8ba2&"
import script from "./AdminMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./AdminMessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports